<template>
  <div>

    <!-- Query settings -->
    <div class="row">
      <div class="col-12">
        <el-card shadow="never">
          <div class="row">
            <div class="col-8">

              <div class="row">
                <div class="col-6">
                  <el-date-picker v-model="queryParams.dateRange" type="datetimerange" format="yyyy-MM-dd h:mmA"
                    range-separator="～" :start-placeholder="$t('Sales.Start_Time')" :end-placeholder="$t('Sales.End_Time')"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions"
                    @change="onDateRangePicked">
                  </el-date-picker>
                </div>
                <div class="col-6">
                  <el-button type="danger" round :disabled="!queryParams.shopId"
                    icon="el-icon-download" @click="exportCartReport">
                    {{ $t("Sales.Order_And_Item_List") }}
                  </el-button>
                  <el-button type="info" round :disabled="!queryParams.shopId"
                    icon="el-icon-download" @click="exportSalesReport">
                    {{ $t("Sales.Product_Sales_List") }}
                  </el-button>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-12">
                  <el-switch class="d-inline" v-model="queryParams.timeBasedOn" @change="applyBasedTimeRange"
                    active-color="#13CE66" inactive-color="#439CFE"
                    :active-text="$t('Sales.Pickup_Time')" :inactive-text="$t('Sales.Order_Time')"
                    active-value="take_meal_time" inactive-value="created_at">
                  </el-switch>
                </div>
              </div>
              
            </div>

            <div class="col-4">
              <!-- <account-selector :user="user" @apply-account="applyAccount">
              </account-selector> -->
              <ShopFinder @shop-selected="onShopSelected" @si-selected="onSiSelected"></ShopFinder>
            </div>
          </div>
          
        </el-card>
      </div>
    </div>
    <br>

    <!-- Data table -->
    <div class="row" >
      <div class="col-12" v-if="queryParams.shopId > 0">
        <data-tables
          :data="products"
          :pagination-props="{pageSizes: [5, 10, 50]}"
          :table-props="productTableProps">
          <el-table-column prop="code" :label="$t('Sales.Product_Code')" width="120" sortable="custom">
          </el-table-column>
          <el-table-column prop="product" :label="$t('Sales.Product_Name')" sortable="custom">
          </el-table-column>
          <el-table-column prop="unit_price" :label="$t('Sales.Unit_Price')" width="120" sortable="custom">
            <div slot-scope="{row}">${{Number(row.unit_price).toLocaleString()}}</div>
          </el-table-column>
          <!-- <el-table-column prop="image" label="圖片" width="120">
            <template slot-scope="{row}">
              <img :src="row.image" alt="...">
            </template>
          </el-table-column> -->
          <el-table-column prop="qty" :label="$t('Sales.Quantity')" width="108" sortable="custom">
          </el-table-column>
          <el-table-column prop="total" :label="$t('Sales.Subtotal')" width="120" sortable="custom" :render-header="addTooltipTotal">
            <div slot-scope="{row}">${{Number(row.total).toLocaleString()}}</div>
          </el-table-column>
        </data-tables>
      </div>

      <div class="col-12 d-flex justify-content-center" v-else>
        <h5>{{ $t('Sales.Message.Choose_shop') }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
// import AccountSelector from '../Summary/AccountSelector.vue';
import ShopFinder from 'src/components/ShopFinder.vue';
import { DataTables } from "vue-data-tables";

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    // AccountSelector,
    ShopFinder,
    DataTables
  },

  mounted() {
    // this.getProductSales();
    console.log(`this.$route`, this.$route);
    if (this.$route.meta && this.$route.meta.retail === true) {
      this.isRetailShop = true;
    }
  },

  methods: {
    getProductSales() {
      if (!this.queryParams.shopId)
        return;
      let from = moment(this.queryParams.dateRange[0]);
      let to = moment(this.queryParams.dateRange[1]);
      if (from.clone().add(31, 'days').isBefore(to)) {
        alert(this.$t('Sales.Message.Up_to_one_month'));
        return;
      }

      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.queryParams.shopId}/sales`
        + `?from=${from.unix()}&to=${to.unix()}&limit=-1&timeBasedOn=${this.queryParams.timeBasedOn}`
      )
      .then(response => {
        // console.log('getProductSales', response.data);
        this.products = response.data.products;
      })
      .catch(err => {
        console.error(`Cannot get product sales`, err);
        this.products = [];
      });
    },

    // applyAccount(si, eaa, shop) {
    //   console.log(`[SALES] applyAccount: SI`, si);
    //   console.log(`[SALES] applyAccount: EAA`, eaa);
    //   console.log(`[SALES] applyAccount: shop`, shop);
    //   if (shop) {
    //     this.queryParams.shopId = shop.id;
    //     this.queryParams.shopName = shop.name;
    //     this.getProductSales();
    //   }
    // },
    applyBasedTimeRange() {
      this.getProductSales();
    },
    onDateRangePicked(fromDate, toDate) {
      // console.log(fromDate, toDate);
      // console.log('model', this.model);
      // this.queryParams.dateRange[1] = moment(this.queryParams.dateRange[1]).endOf('day').toDate();
      this.getProductSales();
    },
    onSiSelected(siId) {
      // When changed, reset shop parameters.
      this.queryParams.shopId = null;
      this.queryParams.shopName = null;
    },
    onShopSelected(shopId, shopName) {
      this.queryParams.shopId = shopId;
      this.queryParams.shopName = shopName;
      if (shopId)
        this.getProductSales();
    },

    exportCartReport() {
      if (!this.queryParams.shopId)
        return;
      let from = moment(this.queryParams.dateRange[0]);
      let to = moment(this.queryParams.dateRange[1]);
      if (this.userType !== 'gaa' && to.diff(from, 'days') > 7) {
        alert(this.$t('Sales.Message.Up_to_one_week_for_export'));
        return;
      }
      window.open(
        `${process.env.VUE_APP_APIHOST}`
        // + `/${this.userType}/orders/export`
        + `/${this.userType}/shops/${this.queryParams.shopId}/sales/export-carts`
        + `?from=${from.unix()}&to=${to.unix()}`
        + `&timeRangeAttr=${this.queryParams.timeBasedOn}`
        + `&fileInitial=${this.queryParams.shopName}&defaultPlatformName=${encodeURIComponent(process.env.VUE_APP_BRANDNAME)}`
        + `&retail=${this.isRetailShop}`
      );
    },
    exportSalesReport() {
      if (!this.queryParams.shopId)
        return;
      let from = moment(this.queryParams.dateRange[0]).startOf('day');
      let to = moment(this.queryParams.dateRange[1]).endOf('day');
      if (to.diff(from, 'days') > 31) {
        alert(this.$t('Sales.Message.Up_to_one_month_for_export'));
        return;
      }
      window.open(
        `${process.env.VUE_APP_APIHOST}`
        + `/${this.userType}/shops/${this.queryParams.shopId}/sales/export`
        + `?from=${from.unix()}&to=${to.unix()}&limit=-1&shopId=${this.queryParams.shopId}`
        + `&timeRangeAttr=${this.queryParams.timeBasedOn}`
        + `&shopName=${this.queryParams.shopName}`
      );
    },

    // This renders tooltips in data-table column headaer.
    addTooltipTotal(h, {column, $index}) {
      return h(
        'el-tooltip',
        {
          props: {
            content: this.$t('Sales.Message.Total_amount_reminder'),
            placement: 'top'
          },
          domProps: {
            innerHTML: column.label + '<span class="el-icon-question"></span>'
          }
        },
        [h('span')]//WARNING: ???
      );
    }
  },
  
  data() {
    return {
      isRetailShop: false,

      queryParams: {
        // from: moment().add(-1, 'weeks').startOf('day'),
        // to: moment().endOf('day'),
        dateRange: [
          moment().startOf('day').toDate(),
          moment().endOf('day').toDate()
        ],
        timeBasedOn: 'created_at',

        shopId: 0
      },
      model: [],

      // Data-table attributes
      products: [],
      productTableProps: {
        defaultSort: {
          prop: 'qty',
          order: 'descending'
        }
      },
    };
  },

  computed: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: this.$t("Sales.Yesterday"),
            onClick(picker) {
              let d = moment().add(-1, 'days');
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          },
          {
            text: this.$t("Sales.Today"),
            onClick(picker) {
              let d = moment();
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          },
          {
            text: this.$t("Sales.Tomorrow"),
            onClick(picker) {
              let d = moment().add(1, 'days');
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          }
        ]
      }
    },
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if (this.userType === 'gaa') return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },
  }
}
</script>